module.exports = __webpack_public_path__ + "static/fonts/Roboto-Light.3c37aa6.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/dist/fonts/roboto/Roboto-Light.woff2
// module id = 451
// module chunks = 1